export type LeavingSiteInterstitialVariant =
  | "generic"
  | "planned-parenthood"
  | "prjkt-ruby"

const HTTP_PROTOCOLS = new Set(["http:", "https:"])

export const AFAXYS_HOST_SUFFIXES = [
  "afaxys.com",
  "afaxyspharma.com",
  "econtra.com",
] as const
export const PLANNED_PARENTHOOD_DIRECT_HREF =
  "https://www.plannedparenthooddirect.org/service/birth-control"
export const PRJKT_RUBY_HREF = "https://www.prjktruby.com/"

const PLANNED_PARENTHOOD_HOST_SUFFIXES = [
  "plannedparenthood.org",
  "plannedparenthooddirect.org",
] as const
const PRJKT_RUBY_HOST_SUFFIXES = ["prjktruby.com"] as const

function normalizeHostname(hostname: string) {
  return hostname.trim().toLowerCase()
}

export function matchesHostnameSuffix(
  hostname: string,
  suffixes: readonly string[],
) {
  const normalizedHostname = normalizeHostname(hostname)

  return suffixes.some(suffix => {
    const normalizedSuffix = normalizeHostname(suffix)

    return (
      normalizedHostname === normalizedSuffix ||
      normalizedHostname.endsWith(`.${normalizedSuffix}`)
    )
  })
}

export function isHttpUrl(url: URL) {
  return HTTP_PROTOCOLS.has(url.protocol)
}

export function getUrlFromHref(href: string, baseHref?: string) {
  try {
    const url = baseHref ? new URL(href, baseHref) : new URL(href)

    return isHttpUrl(url) ? url : null
  } catch {
    return null
  }
}

export function isAbsoluteHttpHref(href: string) {
  return getUrlFromHref(href) !== null
}

export function isExemptExternalHost(hostname: string) {
  return matchesHostnameSuffix(hostname, AFAXYS_HOST_SUFFIXES)
}

export function getLeavingSiteInterstitialVariant(hostname: string): LeavingSiteInterstitialVariant {
  if (matchesHostnameSuffix(hostname, PRJKT_RUBY_HOST_SUFFIXES)) {
    return "prjkt-ruby"
  }

  if (matchesHostnameSuffix(hostname, PLANNED_PARENTHOOD_HOST_SUFFIXES)) {
    return "planned-parenthood"
  }

  return "generic"
}
